/**
 *
 * @param {object} configuration
 * @param {string} exclude
 * @returns array
 */
const getFlattenedConfiguration = (configuration, exclude = 'none') => {
    let result = [];
    Object.keys(configuration).forEach((configurationSection) => {
        if (configurationSection !== exclude) {
            switch (configurationSection) {
                case 'engine':
                case 'paintwork':
                    if (configuration[configurationSection] !== null) {
                        result.push(configuration[configurationSection]);
                    }
                    break;
                default:
                    result = result.concat(configuration[configurationSection]);
            }
        }
    });
    return result;
};

export default getFlattenedConfiguration;
